<template>
  <aside class="left-bar" :class="{ collapsed: isCollapsed }">


    <!-- 토글 버튼 -->
    <button class="toggle-btn" @click="isCollapsed = !isCollapsed">
      <i :class="isCollapsed ? 'fa-solid fa-chevron-right' : 'fa-solid fa-chevron-left'"></i>
    </button>



    <ul class="menu-list">
      <li v-for="menu in menus" :key="menu.key" :class="['menu-item', { active: menu.key === activeMenu }]"
        @click="$emit('select', menu.key)">
        <!-- Font Awesome 아이콘 -->
        <span class="icon">
          <i :class="menu.icon"></i>
        </span>

        <span class="label">{{ menu.label }}</span>
      </li>
    </ul>
  </aside>
</template>

<script>
export default {
  name: 'LeftBar',

  props: {
    menus: {
      type: Array,
      required: true
    },
    activeMenu: {
      type: String,
      default: ''
    }
  },
  emits: ['select']

  , data() {
    return {
      isCollapsed: false
    }
  }
}
</script>

<style scoped>
.left-bar {
  position: relative;
  width: 220px;
  min-width: 220px;
  height: calc(100% - 20px);
  margin: 10px;
  padding: 12px;
  box-sizing: border-box;
  overflow: visible;

  background-color: var(--color-white);
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);

  transition: width 0.16s ease, min-width 0.16s ease;
}

.left-bar.collapsed {
  width: 80px;
  min-width: 80px;
}

.title {
  padding: 8px 16px;
  margin-bottom: 8px;

  font-size: 0.9rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  color: var(--color-primary);
}

.menu-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 12px;

  width: 100%;
  min-height: 50px;
  margin-bottom: 8px;
  padding: 12px 14px;
  box-sizing: border-box;

  border-radius: 8px;
  cursor: pointer;
  user-select: none;

  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-main);

  transition: background-color 0.15s ease, color 0.15s ease;
}

.menu-item:hover {
  background-color: var(--color-bg-hover);
}

.menu-item.active {
  background-color: var(--color-bg-hover);
  color: var(--color-primary);
  font-weight: 700;
}

.icon {
  width: 18px;
  min-width: 18px;
  height: 18px;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 1rem;
  color: currentColor;
  flex-shrink: 0;
}

.label {
  display: inline-block;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;

  opacity: 1;
  transform: translateX(0);
  transition: opacity 0.12s ease, transform 0.12s ease;
}

.left-bar.collapsed .menu-item {
  justify-content: center;
  gap: 0;
  padding: 12px 0;
}

.left-bar.collapsed .label {
  width: 0;
  opacity: 0;
  transform: translateX(-6px);
  pointer-events: none;
}

.toggle-btn {
  position: absolute;
  top: 50%;
  right: -14px;
  transform: translateY(-50%);

  width: 30px;
  height: 30px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: none;
  border-radius: 20%;
  cursor: pointer;
  z-index: 10;

  background-color: var(--color-primary-border);
  color: var(--color-primary-soft);
  box-shadow: 0 4px 8px var(--color-text-sub);
}

.toggle-btn i {
  pointer-events: none;
}

@media (max-width: 1100px) {
  .left-bar {
    width: 80px;
    min-width: 80px;
  }

  .left-bar .menu-item {
    justify-content: center;
    gap: 0;
    padding: 12px 0;
  }

  .left-bar .label {
    width: 0;
    opacity: 0;
    transform: translateX(-6px);
    pointer-events: none;
  }
}
</style>